import { Mail } from 'lucide-react'
import { Button } from '@/components/ui/button'
import { Card, CardContent, CardHeader, CardTitle } from '@/components/ui/card'

type Props = {
    preference: { email: string; enabled: boolean | null; canManage: boolean; message: string | null } | null | undefined
    impersonating: boolean
    saving: boolean
    feedback?: { message: string; error: boolean } | null
    onToggle: () => void
}

export function EmailNotificationPreferences({ preference, impersonating, saving, feedback, onToggle }: Props) {
    return (
        <Card id="email-notifications" className="scroll-mt-6">
            <CardHeader>
                <CardTitle className="flex items-center text-xl">
                    <Mail className="mr-2 h-5 w-5 shrink-0" aria-hidden="true" />
                    Notifiche email
                </CardTitle>
            </CardHeader>
            <CardContent className="space-y-4">
                {impersonating ? (
                    <p className="text-sm text-gray-700">Termina l’impersonificazione per gestire le notifiche email del tuo account.</p>
                ) : preference === undefined ? (
                    <p role="status" className="text-sm text-gray-700">Caricamento delle preferenze email…</p>
                ) : preference === null ? (
                    <p role="status" className="text-sm text-gray-700">Accedi con un account attivo per gestire le notifiche email.</p>
                ) : !preference.canManage ? (
                    <div className="space-y-2 text-sm text-gray-700">
                        <p className="break-all font-medium text-gray-900">{preference.email}</p>
                        <p role="status" className="max-w-2xl leading-relaxed">{preference.message}</p>
                    </div>
                ) : (
                    <>
                        <div className="flex flex-col gap-4 sm:flex-row sm:items-start sm:justify-between">
                            <div className="min-w-0 space-y-1">
                                <p className="font-medium text-gray-900">Notifiche operative {preference.enabled ? 'attive' : 'disattivate'}</p>
                                <p className="break-all text-sm text-gray-700">{preference.email}</p>
                            </div>
                            <Button type="button" variant="outline" className="shrink-0" onClick={onToggle} disabled={saving} aria-describedby="email-notifications-description">
                                {saving ? 'Salvataggio…' : preference.enabled ? 'Disattiva notifiche email' : 'Riattiva notifiche email'}
                            </Button>
                        </div>
                        <p id="email-notifications-description" className="max-w-2xl text-sm leading-relaxed text-gray-700">
                            La scelta vale per questo indirizzo in tutte le tue cliniche. Disattivando le email, segui nel portale gli aggiornamenti su prescrizioni, approvazioni e richieste. Chat e notifiche nel portale restano disponibili.
                        </p>
                        <p className="text-sm leading-relaxed text-gray-600">Le email di accesso e recupero password restano attive.</p>
                        {feedback && <p role={feedback.error ? 'alert' : 'status'} className={`text-sm ${feedback.error ? 'text-red-700' : 'text-gray-900'}`}>{feedback.message}</p>}
                    </>
                )}
            </CardContent>
        </Card>
    )
}
